var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0012 23.5379V26.4722C49.9644 26.6105 49.9366 26.751 49.9181 26.8928C49.6745 30.3798 48.752 33.6829 47.0645 36.7375C43.1759 43.7799 37.2711 48.0895 29.3579 49.6094C28.4041 49.7923 27.4317 49.8755 26.4681 50.0007H23.5333C23.41 49.9648 23.2841 49.9384 23.1567 49.9215C19.6673 49.6828 16.3519 48.7849 13.3046 47.0791C5.08722 42.4819 0.620466 35.4484 0.0413343 26.0497C-0.254883 21.6012 0.753866 17.163 2.94385 13.2795C7.53288 5.08292 14.5656 0.63056 23.9481 0.0505408C28.4579 -0.227243 32.7584 0.76554 36.7223 2.94575C43.7782 6.81972 48.0731 12.7213 49.607 20.6505C49.7899 21.6032 49.8721 22.5745 50.0012 23.5379ZM38.2415 7.66807C30.1914 1.37686 18.9874 1.89721 11.7824 7.66807C17.294 12.1282 20.2855 17.8746 20.2933 24.9904C20.3012 32.1062 17.3087 37.8809 11.7952 42.3538C20.2836 48.9737 31.7684 47.707 38.2083 42.3411C26.8604 33.6134 26.9455 16.3811 38.2415 7.66807ZM40.6432 40.1795C49.6794 30.9755 48.0154 16.7469 40.5737 9.84925C29.8275 17.636 30.567 33.1752 40.6432 40.1795ZM9.3857 40.1795C20.0302 32.6148 19.5264 16.8408 9.3857 9.85317C1.37177 17.6976 0.936447 31.711 9.3857 40.1756V40.1795Z",
    fill: "#EAC7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallBtn);
export default __webpack_public_path__ + "static/media/ball-btn.ab6cf7dcf4c04b47968aa92fe9b56e6c.svg";
export { ForwardRef as ReactComponent };